import { DEFAULT_OVERCHARGE_CLAIMS_TABLE_VIEW_COLUMNS } from '@/contants/ClaimsEnums';
import { generateUUIDv4 } from '@/utils/number';

export interface OCTableViewColumn {
  columnName: string;
  columnValue: string;
  id: string;
}

export const normalizeColumns = (columns: { columnName: string; columnValue: string }[]): OCTableViewColumn[] => {
  return columns.map((row) => ({ ...row, id: generateUUIDv4() }));
};

export const OC_FIXED_COLUMN_LABELS: ReadonlyArray<string> = ['Claim Number'];

export const normalizeResponse = (
  response: { fieldReferenceName: string; fieldReferenceValue: string }[] | null | undefined,
): OCTableViewColumn[] => {
  const columns = !response?.length
    ? DEFAULT_OVERCHARGE_CLAIMS_TABLE_VIEW_COLUMNS
    : response
        .filter(({ fieldReferenceName }) => !OC_FIXED_COLUMN_LABELS.includes(fieldReferenceName))
        .map(({ fieldReferenceName, fieldReferenceValue }) => ({
          columnName: fieldReferenceName,
          columnValue: fieldReferenceValue,
        }));
  return normalizeColumns(columns);
};
